var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fa-stack fa-lg visitado-checkbox",class:{active:_vm.value===true}},[_c('i',{staticClass:"fa fa-circle fa-stack-2x"}),_c('i',{staticClass:"fa fa-check fa-stack-1x fa-inverse"})])
}
var staticRenderFns = []

export { render, staticRenderFns }